import axios from 'axios';
import { HTTP_CONFIG } from '@/config/config.js'

const API_BASE_URL = HTTP_CONFIG.API_BASE_URL;
/* eslint-disable */
export const getEngerySataistic = async () => {
  const elect_detail = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-energy-statistics/`,
    {params: {fac_type: '电表'}}
  )
  const water_detail = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-energy-statistics/`,
    {params: {fac_type: '水表'}}
  )
  const cold_detail = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-energy-statistics/`,
    {params: {fac_type: '冷气表'}}
  )
  const liuliang_detail = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-energy-statistics/`,
    {params: {fac_type: '流量计'}}
  )
  const elect_list = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-energy-comparison/`,
    {params: {fac_type: '电表'}}
  )
  const water_list = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-energy-comparison/`,
    {params: {fac_type: '水表'}}
  )
  const cold_list = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-energy-comparison/`,
    {params: {fac_type: '冷气表'}}
  )
  const liuliang_list = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-energy-comparison/`,
    {params: {fac_type: '流量计'}}
  )
  const fault_list = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-fault-meter-comparison/`)
  const data = {
    data: {
      detail: [
        {
          color: '#f6628b',
          title: '本年电量',
          num: `电表总数: ${elect_detail.data.data[0].meter_count}`,
          value: `${elect_detail.data.data[0].total_data}kW`,
          fault: `故障总数: ${elect_detail.data.data[0].fault_count}`,
          gap: true
        },
        {
          color: '#32bafb',
          title: '本年水量',
          num: `水表总数: ${water_detail.data.data[0].meter_count}`,
          value: `${water_detail.data.data[0].total_data}吨`,
          fault: `故障总数: ${water_detail.data.data[0].fault_count}`,
          gap: true
        },
        {
          color: '#fbbe47',
          title: '本年流量',
          num: `流量计总数: ${liuliang_detail.data.data[0].meter_count}`,
          value: `${liuliang_detail.data.data[0].total_data}m³`,
          fault: `故障总数: ${liuliang_detail.data.data[0].fault_count}`,
          gap: true
        },
        {
          color: '#6fc470',
          title: '本年时长',
          num: `冷气表总数: ${liuliang_detail.data.data[0].meter_count}`,
          value: `${liuliang_detail.data.data[0].total_data}时`,
          fault: `故障总数: ${liuliang_detail.data.data[0].fault_count}`,
          gap: false
        }
      ],
      elect: {
        thiselect: elect_list.data.data[0].this_year,
        lastelect: elect_list.data.data[0].last_year
      },
      water: {
        thiswater: water_list.data.data[0].this_year,
        lastwater: water_list.data.data[0].last_year
      },
      flow: {
        thisflow: liuliang_list.data.data[0].this_year,
        lastflow: liuliang_list.data.data[0].last_year
      },
      cold: {
        thiscold: cold_list.data.data[0].this_year,
        lastcold: cold_list.data.data[0].last_year
      },
      error: {
        elect: fault_list.data.data.ele_meter,
        water: fault_list.data.data.water_meter,
        flow: fault_list.data.data.flow_meter,
        cold: fault_list.data.data.glass_meter
      }
    }
  }
  return data
}

export const getErrLogs = () => {
  const data = {
    data: {
      errlogs: [
        {
          id: '1',
          name: '1-1一楼气表1',
          type: '流量计',
          issue: '流量异常报警',
          time: '2026-6-18 16:12'
        }
      ]
    }
  }
  return data
}

export const getChangqu = async () => {
  const response = await axios.get(`${API_BASE_URL}parking/query_park_message/`)
  const result = {
    data: [
      {park_id: "00", value: '全部', label: '全部'},
    ]
  }
  for(let i = 0;i < response.data.data.length;i++) {
    let item = {}
    item.park_id = response.data.data[i].park_id
    item.value = response.data.data[i].name
    item.label = response.data.data[i].name
    result.data.push(item)
  }
  return result
}

export const getEditChangqu = async () => {
  const response = await axios.get(`${API_BASE_URL}parking/query_park_message/`)
  const result = {
    data: []
  }
  for(let i = 0;i < response.data.data.length;i++) {
    let item = {}
    item.park_id = response.data.data[i].park_id
    item.value = response.data.data[i].name
    item.label = response.data.data[i].name
    result.data.push(item)
  }
  return result
}

export const getLouhao = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/query_park_message/`,
    {params: {park_id: param}}
  )
  const result = {
    data: [
      {building_id: "00000", value: '全部', label: '全部'},
    ]
  }
  for(let i = 0;i < response.data.data.length;i++) {
    let item = {}
    item.building_id = response.data.data[i].building_id
    item.value = response.data.data[i].name
    item.label = response.data.data[i].name
    result.data.push(item)
  }
  return result;
}

export const getLouCeng = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/query_park_message/`,
    {params: {building_id: param}}
  )
  const result = {
    data: [
      {floor_id: "00000", value: '全部', label: '全部'},
    ]
  }
  for(let i = 0;i < response.data.data.length;i++) {
    let item = {}
    item.floor_id = response.data.data[i].floor_id
    item.value = response.data.data[i].name
    item.label = response.data.data[i].name
    result.data.push(item)
  }
  return result;
}

export const getEditLouhao = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/query_park_message/`,
    {params: {park_id: param}}
  )
  const result = {
    data: []
  }
  for(let i = 0;i < response.data.data.length;i++) {
    let item = {}
    item.building_id = response.data.data[i].building_id
    item.value = response.data.data[i].name
    item.label = response.data.data[i].name
    result.data.push(item)
  }
  return result;
}

export const getEditLouCeng = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/query_park_message/`,
    {params: {building_id: param}}
  )
  const result = {
    data: []
  }
  for(let i = 0;i < response.data.data.length;i++) {
    let item = {}
    item.floor_id = response.data.data[i].floor_id
    item.value = response.data.data[i].name
    item.label = response.data.data[i].name
    result.data.push(item)
  }
  return result;
}

export const getMonitorData = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/management/realtime-data/`,
    {
      params: {
        page: param.currpage,
        page_size: param.pagesize,
        meter__fac_state: ((param.state == '全部')) ? ('') : (param.state),
        meter__install_park: ((param.changqu == '全部')) ? ('') : (param.changqu),
        meter__install_building: ((param.louhao == '全部')) ? ('') : (param.louhao),
        meter__install_floor: ((param.louceng == '全部')) ? ('') : (param.louceng),
        meter_read_type: ((param.paratype == '全部')) ? ('') : (param.paratype),
        search: param.sn
      }
    }
  )
  const data = response.data
  const result = {
    totalpage: data.count,
    data: []
  }
  for(let i = 0;i < data.results.length;i++) {
    let item = {}
    item.id = i + 1
    item.meterid = data.results[i].meter.id
    item.sn = data.results[i].meter.fac_id
    item.name = data.results[i].meter.fac_name
    item.value = data.results[i].meter_data
    item.metertype = data.results[i].meter.fac_type
    item.state = data.results[i].meter.fac_state
    item.errtype = data.results[i].meter.fault_type
    item.errmsg = data.results[i].meter.fault_description
    item.location = data.results[i].meter.install_park + data.results[i].meter.install_building + data.results[i].meter.install_floor + data.results[i].meter.detail_area
    item.paratype = data.results[i].meter_read_type
    item.datetime = data.results[i].upload_time
    result.data.push(item)
  }
  return result
}
export const getMeterHistory = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/management/meter-messages/${param.row.meterid}/get-history-data/`,
    {
      params: {
        page: param.currpage,
        page_size: param.pagesize,
        start_date: param.startTime,
        end_date: param.endTime
      }
    }
  )
  const data = response.data
  const result = {
    totalpage: data.count,
    data: []
  }
  for(let i = 0;i < data.results.length;i++) {
    let item = {}
    item.id = i + 1
    item.value = data.results[i].data
    item.datetime = data.results[i].upload_time
    item.user = data.results[i].meter_person
    item.paratype = data.results[i].meter_read_type
    result.data.push(item)
  }
  return result
}

export const getMapTree = async () => {
  const data = {
    data: [
      {
        id: '1',
        name: '泰山路园区',
        children: [
          {
            id: '11',
            name: '1号楼',
            children: [
              {
                id: '111',
                name: '一层',
              },
              {
                id: '112',
                name: '二层',
              },
              {
                id: '113',
                name: '三层',
              },
              {
                id: '114',
                name: '四层',
              }
            ]
          },
          {
            id: '12',
            name: '6号楼',
            children: [
              {
                id: '121',
                name: '一层',
              },
              {
                id: '122',
                name: '二层',
              },
              {
                id: '123',
                name: '三层',
              },
              {
                id: '124',
                name: '四层',
              }
            ]
          },
          {
            id: '13',
            name: '8号楼',
            children: [
              {
                id: '131',
                name: '一层',
              },
              {
                id: '132',
                name: '二层',
              },
              {
                id: '133',
                name: '三层',
              },
              {
                id: '134',
                name: '四层',
              }
            ]
          },
          {
            id: '14',
            name: '9号楼',
            children: [
              {
                id: '141',
                name: '一层',
              },
              {
                id: '142',
                name: '二层',
              }
            ]
          },
          {
            id: '15',
            name: '宿舍楼',
            children: [
              {
                id: '151',
                name: '一层',
              },
              {
                id: '152',
                name: '二层',
              },
              {
                id: '153',
                name: '三层',
              },
              {
                id: '154',
                name: '四层',
              }
            ]
          },
          {
            id: '16',
            name: '11号楼',
            children: [
              {
                id: '161',
                name: '一层',
              },
              {
                id: '162',
                name: '二层',
              },
              {
                id: '163',
                name: '三层',
              },
              {
                id: '164',
                name: '四层',
              },
              {
                id: '165',
                name: '五层',
              }
            ]
          },
          {
            id: '17',
            name: '12号楼',
            children: [
              {
                id: '171',
                name: '一层',
              }
            ]
          },
          {
            id: '18',
            name: '13号楼',
            children: [
              {
                id: '181',
                name: '一层',
              }
            ]
          },
          {
            id: '19',
            name: '14号楼',
            children: [
              {
                id: '191',
                name: '一层',
              },
              {
                id: '192',
                name: '二层',
              },
              {
                id: '193',
                name: '三层',
              },
              {
                id: '194',
                name: '四层',
              }
            ]
          },
          {
            id: '1a',
            name: '15号楼',
            children: [
              {
                id: '1a1',
                name: '一层',
              }
            ]
          },
          {
            id: '1b',
            name: '16号楼',
            children: [
              {
                id: '1b1',
                name: '一层',
              },
              {
                id: '1b2',
                name: '二层',
              },
              {
                id: '1b3',
                name: '三层',
              },
              {
                id: '1b4',
                name: '四层',
              }
            ]
          },
          {
            id: '1c',
            name: '硕博楼',
            children: [
              {
                id: '1c1',
                name: '一层',
              },
              {
                id: '1c2',
                name: '二层',
              },
              {
                id: '1c3',
                name: '三层',
              }
            ]
          },
          {
            id: '1d',
            name: '105号楼',
            children: [
              {
                id: '1d1',
                name: '一层',
              },
              {
                id: '1d2',
                name: '二层',
              },
              {
                id: '1d3',
                name: '三层',
              },
              {
                id: '1d4',
                name: '四层',
              },
              {
                id: '1d5',
                name: '五层',
              },
              {
                id: '1d6',
                name: '六层',
              }
            ]
          },
          {
            id: '1e',
            name: '106号楼',
            children: [
              {
                id: '1e1',
                name: '一层',
              },
              {
                id: '1e2',
                name: '二层',
              },
              {
                id: '1e3',
                name: '三层',
              },
              {
                id: '1e4',
                name: '四层',
              },
              {
                id: '1e5',
                name: '五层',
              },
              {
                id: '1e6',
                name: '六层',
              }
            ]
          },
        ]
      },
      {
        id: '2',
        name: '梅江道园区',
        children: [
          {
            id: '21',
            name: '1号楼',
            children: [
              {
                id: '211',
                name: '一层',
              },
              {
                id: '212',
                name: '二层',
              },
              {
                id: '213',
                name: '三层',
              }
            ]
          },
          {
            id: '22',
            name: '2号楼',
            children: [
              {
                id: '221',
                name: '一层',
              },
              {
                id: '222',
                name: '二层',
              }
            ]
          },
          {
            id: '23',
            name: '3号楼',
            children: [
              {
                id: '231',
                name: '一层',
              },
              {
                id: '232',
                name: '二层',
              }
            ]
          },
          {
            id: '24',
            name: '4号楼',
            children: [
              {
                id: '241',
                name: '一层',
              },
              {
                id: '242',
                name: '二层',
              }
            ]
          },
          {
            id: '25',
            name: '5号楼',
            children: [
              {
                id: '251',
                name: '一层',
              }
            ]
          },
          {
            id: '26',
            name: '6号楼',
            children: [
              {
                id: '261',
                name: '一层',
              },
              {
                id: '262',
                name: '二层',
              }
            ]
          },
          {
            id: '27',
            name: '7号楼',
            children: [
              {
                id: '271',
                name: '一层',
              },
              {
                id: '272',
                name: '二层',
              },
              {
                id: '273',
                name: '三层',
              }
            ]
          },
          {
            id: '28',
            name: '8号楼',
            children: [
              {
                id: '281',
                name: '一层',
              },
              {
                id: '282',
                name: '二层',
              }
            ]
          },
          {
            id: '29',
            name: '9号楼',
            children: [
              {
                id: '291',
                name: '一层',
              },
              {
                id: '292',
                name: '二层',
              }
            ]
          },
          {
            id: '2a',
            name: '10号楼',
            children: [
              {
                id: '2a1',
                name: '一层',
              },
              {
                id: '2a2',
                name: '二层',
              }
            ]
          }
        ]
      }
    ]
  }
  return data
}

export const getCompany = async () => {
  const response = await axios.get(`${API_BASE_URL}parking/company_list/`)
  const result = {
    data: [
      {company_id: 0, value: '全部', label: '全部'}
    ]
  }
  const data = response.data
  for(let i = 0;i < data.data.length;i++) {
    let item = {}
    item.company_id = data.data[i].company_id
    item.value = data.data[i].name
    item.label = data.data[i].name
    result.data.push(item)
  }
  return result
}

export const getEditCompany = async () => {
  const response = await axios.get(`${API_BASE_URL}parking/company_list/`)
  const result = {
    data: []
  }
  const data = response.data
  for(let i = 0;i < data.data.length;i++) {
    let item = {}
    item.company_id = data.data[i].company_id
    item.value = data.data[i].name
    item.label = data.data[i].name
    result.data.push(item)
  }
  return result
}

export const getSampleData = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/management/meter-data/get-meter-management/`,
  {
    params: {
      page: param.currpage,
      page_size: param.pagesize,
      fac_type: ((param.devtype == '全部')) ? ('') : (param.devtype),
      search: param.sn,
      meter_read_type: ((param.sampletype == '全部')) ? ('') : (param.sampletype),
      install_park: ((param.changqu == '全部')) ? ('') : (param.changqu),
      install_building: ((param.louhao == '全部')) ? ('') : (param.louhao),
      install_floor: ((param.louceng == '全部')) ? ('') : (param.louceng),
      company: ((param.company == '全部')) ? ('') : (param.company),
      start_date: param.startTime,
      end_date: param.endTime
    }
  })
  const data = response.data
  const result = {
    totalpage: data.count,
    data: []
  }
  for(let i = 0;i < data.results.length;i++) {
    let item = {}
    item.id = i + 1
    item.sn = data.results[i].fac_id
    item.name = data.results[i].fac_name
    item.devtype = data.results[i].fac_type
    item.lastvalue = data.results[i].meter_last_data
    item.thisvalue = data.results[i].meter_data
    item.usevalue = data.results[i].usage
    item.location = data.results[i].install_area
    item.company = data.results[i].company
    item.datetime = data.results[i].upload_time
    item.paratype = data.results[i].meter_read_type
    item.parafrom = data.results[i].meter_person
    result.data.push(item)
  }
  return result
}

export const addMeterValue = async (id, param) => {
  const response = await axios.post(`${API_BASE_URL}parking/management/meter-data/${id}/upload/`, {
    data: parseFloat(param.value),
    upload_time: param.datetime,
    meter_read_type: param.paratype,
    meter_person: param.manualuser
  })
  return response.data
}

export const getNenghao = async (param1, param2) => {
  const response = await axios.get(`${API_BASE_URL}parking/management/meter-data/get-energy-consumption/`,
  {
    params: {
      page: param1.currpage,
      page_size: param1.pagesize,
      fac_type: ((param2.devtype == '全部')) ? ('') : (param2.devtype),
      install_park: ((param2.changqu == '全部')) ? ('') : (param2.changqu),
      install_building: ((param2.louhao == '全部')) ? ('') : (param2.louhao),
      install_floor: ((param2.louceng == '全部')) ? ('') : (param2.louceng),
      company: ((param2.company == '全部')) ? ('') : (param2.company),
      search: param2.sn,
      meter_read_type: ((param2.paratype == '全部')) ? ('') : (param2.paratype),
      start_date: param2.startTime,
      end_date: param2.endTime
    }
  })
  const data = response.data
  const result = {
    totalpage: data.count,
    data: []
  }
  for(let i = 0;i < data.results.length;i++) {
    let item = {}
    item.id = i + 1
    item.sn = data.results[i].fac_id
    item.name = data.results[i].fac_name
    item.devtype = data.results[i].fac_type
    item.startdata = data.results[i].start_data
    item.enddata = data.results[i].end_data
    item.rate = data.results[i].rate
    item.sum = data.results[i].usage
    item.location = data.results[i].install_area
    result.data.push(item)
  }
  return result
}

export const editMeter = async (id, param) => {
  const response = await axios.put(`${API_BASE_URL}parking/management/meter-messages/${id}/`, {
    fac_id: param.sn,
    fac_name: param.name,
    fac_type: param.devtype,
    install_date: param.installdata,
    install_park: param.changqu,
    install_building: param.louhao,
    install_floor: param.louceng,
    detail_area: param.detail,
    init_data: param.initvalue,
    precision: parseFloat(param.scale),
    rate: parseFloat(param.rate),
    fac_factory: param.changjia,
    company: param.company,
    company_percent: param.zhanbi,
    meter_read_type: param.paratype
  })
  return response.data
}

export const saveMeter = async (param) => {
  const response = await axios.post(`${API_BASE_URL}parking/management/meter-messages/`, {
    fac_id: param.sn,
    fac_name: param.name,
    fac_type: param.devtype,
    install_date: param.installdata,
    install_park: param.changqu,
    install_building: param.louhao,
    install_floor: param.louceng,
    detail_area: param.detail,
    init_data: param.initvalue,
    precision: parseFloat(param.scale),
    rate: parseFloat(param.rate),
    fac_factory: param.changjia,
    company: param.company,
    company_percent: param.zhanbi,
    meter_read_type: param.paratype
  })
  return response.data
}

export const getMeterList = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/management/meter-messages/`,
  {
    params: {
      page: param.currpage,
      page_size: param.pagesize,
      fac_type: ((param.devtype == '全部')) ? ('') : (param.devtype),
      install_park: ((param.changqu == '全部')) ? ('') : (param.changqu),
      install_building: ((param.louhao == '全部')) ? ('') : (param.louhao),
      install_floor: ((param.louceng == '全部')) ? ('') : (param.louceng),
      company: ((param.company == '全部')) ? ('') : (param.company),
      search: param.sn,
      meter_read_type: ((param.paratype == '全部')) ? ('') : (param.paratype),
      start_date: param.startTime,
      end_date: param.endTime
    }
  })
  const data = response.data
  const result = {
    totalpage: data.count,
    data: []
  }
  for(let i = 0;i < data.results.length;i++) {
    let item = {}
    item.id = i + 1
    item.iid = data.results[i].id
    item.sn = data.results[i].fac_id
    item.name = data.results[i].fac_name
    item.devtype = data.results[i].fac_type
    item.installdata = data.results[i].install_date
    item.changqu = data.results[i].install_park
    item.louhao = data.results[i].install_building
    item.louceng = data.results[i].install_floor
    item.detail = data.results[i].detail_area
    item.location = data.results[i].install_park + data.results[i].install_building + data.results[i].install_floor + data.results[i].detail_area
    item.initvalue = data.results[i].init_data
    item.scale = data.results[i].precision
    item.rate = data.results[i].rate
    item.changjia = data.results[i].fac_factory
    item.company = data.results[i].company
    item.zhanbi = data.results[i].company_percent
    item.company1 = data.results[i].company + '(' + data.results[i].company_percent + '%)'
    item.paratype = data.results[i].meter_read_type
    result.data.push(item)
  }
  return result
}

export const getHistoryList = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/management/meter-data/get-meter-history/`,
  {
    params: {
      page: param.currpage,
      page_size: param.pagesize,
      fac_type: ((param.devtype == '全部')) ? ('') : (param.devtype),
      install_park: ((param.changqu == '全部')) ? ('') : (param.changqu),
      install_building: ((param.louhao == '全部')) ? ('') : (param.louhao),
      install_floor: ((param.louceng == '全部')) ? ('') : (param.louceng),
      search: param.sn,
      meter_read_type: ((param.paratype == '全部')) ? ('') : (param.paratype),
      start_date: param.startTime,
      end_date: param.endTime
    }
  })
  const data = response.data
  const result = {
    totalpage: data.count,
    data: []
  }
  for(let i = 0;i < data.results.length;i++) {
    let item = {}
    item.id = i + 1
    item.sn = data.results[i].fac_id
    item.name = data.results[i].fac_name
    item.devtype = data.results[i].fac_type
    item.value = data.results[i].data
    item.location = data.results[i].install_area
    item.paratype = data.results[i].meter_read_type
    item.datetime = data.results[i].upload_time
    result.data.push(item)
  }
  return result
}

export const getRepairList = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/management/meter-maintenance/`,
  {
    params: {
      page: param.currpage,
      page_size: param.pagesize,
      meter__fac_type: ((param.devtype == '全部')) ? ('') : (param.devtype),
      search: param.sn,
      start_date: param.startTime,
      end_date: param.endTime
    }
  })
  const data = response.data
  const result = {
    totalpage: data.count,
    data: []
  }
  for(let i = 0;i < data.results.length;i++) {
    let item = {}
    item.id = i + 1
    item.iid = data.results[i].id
    item.sn = data.results[i].meter_detail.fac_id
    item.name = data.results[i].meter_detail.fac_name
    item.devtype = data.results[i].meter_detail.fac_type
    item.location = data.results[i].meter_detail.install_park + data.results[i].meter_detail.install_building + data.results[i].meter_detail.install_floor + data.results[i].meter_detail.detail_area
    item.submituser = data.results[i].declare_person
    item.submitdate = data.results[i].declare_time
    item.errimg = (data.results[i].fault_photo == null) ? ('') : (data.results[i].fault_photo)
    item.errlog = data.results[i].fault_instruction
    item.state = (data.results[i].resolve_state == true) ?('已解决') : ('未解决')
    item.repairlog = data.results[i].resolve_instruction
    item.repairimg = (data.results[i].resolve_photo == null) ? ('') : (data.results[i].resolve_photo)
    item.repairuser = data.results[i].resolve_person
    item.repairdate = data.results[i].resolve_time
    result.data.push(item)
  }
  return result
}

export const addRepair = async (param) => {
  const response = await axios.post(`${API_BASE_URL}parking/management/meter-maintenance/`, param)
  return response.data
}

export const editRepair = async (id, param) => {
  const response = await axios.put(`${API_BASE_URL}parking/management/meter-maintenance/${id}/`, param)
  return response.data
}

export const delRepair = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}parking/management/meter-maintenance/${id}/`)
  return response.data
}


export const getDayReport = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-daily-statistics/`,
  {
    params: {
      fac_type: ((param.devtype == '全部')) ? ('') : (param.devtype),
      install_park: ((param.changqu == '全部')) ? ('') : (param.changqu),
      install_building: ((param.louhao == '全部')) ? ('') : (param.louhao),
      install_floor: ((param.louceng == '全部')) ? ('') : (param.louceng),
      statistic_date: param.seldate,
    }
  })
  const result = {
    data: []
  }
  const data = response.data.data
  for(let i = 0;i < data.length;i++) {
    let item = {}
    item.id = data[i].fac_id
    item.name = data[i].fac_name
    item.location = data[i].area
    for(let j = 0;j < data[i].daily_data.length;j++) {
      let key = `day${data[i].daily_data[j].day}`
      item[key] = data[i].daily_data[j].usage
    }
    result.data.push(item)
  }
  return result
}

export const getMonReport = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-monthly-statistics/`,
  {
    params: {
      fac_type: ((param.devtype == '全部')) ? ('') : (param.devtype),
      install_park: ((param.changqu == '全部')) ? ('') : (param.changqu),
      install_building: ((param.louhao == '全部')) ? ('') : (param.louhao),
      install_floor: ((param.louceng == '全部')) ? ('') : (param.louceng),
      year: param.seldate,
    }
  })
  const result = {
    data: []
  }
  const data = response.data.data
  for(let i = 0;i < data.length;i++) {
    let item = {}
    item.id = data[i].fac_id
    item.name = data[i].fac_name
    item.location = data[i].area
    for(let j = 0;j < data[i].daily_data.length;j++) {
      let key = `mon${data[i].daily_data[j].month}`
      item[key] = data[i].daily_data[j].usage
    }
    result.data.push(item)
  }
  return result
}

export const getMonNenghao = async (xdata, param) => {
  const response = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-meter-analyze/`,
  {
    params: {
      fac_type: param.devtype,
      start_date: param.startTime,
      end_date: param.endTime
    }
  })
  const data = response.data.data[0]
  let y1data = []
  let y2data = []
  for(let i = 0;i < xdata.length;i++) {
    const label = xdata[i]
    const value1 = data.this_year_data[label]
    if(value1 == undefined) {
      y1data.push(0)
    } else {
      y1data.push(value1)
    }
    const value2 = data.last_year_data[label]
    if(value2 == undefined) {
      y2data.push(0)
    } else {
      y2data.push(value2)
    }
  }
  let maxmeters = []
  for(let i = 0;i < data.max_record_meter.length;i++) {
    let item = {}
    item.id = data.max_record_meter[i].fac_id
    item.name = data.max_record_meter[i].fac_name
    item.location = data.max_record_meter[i].area
    item.value = data.max_record_meter[i].usage
    maxmeters.push(item)
  }
  let errlist = []
  for(let i = 0;i < data.abnormal_list.length;i++) {
    let item = {
      id: data.abnormal_list[i].fac_id,
      name: data.abnormal_list[i].fac_name,
      xdata: xdata,
      y1data: [...data.abnormal_list[i].this_list],
      y2data: [...data.abnormal_list[i].last_list]
    }
    while(item.y1data.length < xdata.length) {
      item.y1data.unshift(0)
    }
    while(item.y2data.length < xdata.length) {
      item.y2data.unshift(0)
    }
    errlist.push(item)
  }
  const result = {
    data: {
      xdata: xdata,
      y1data: y1data,
      y2data: y2data,
      maxmeters: maxmeters,
      errlist: errlist
    }
  }
  return result
}

export const getWxFenxi = async (param) => {
  const response = await axios.get(`${API_BASE_URL}parking/management/meter-statistic/get-repair-analyze/`,
  {
    params: {
      start_date: param.starttime,
      end_date: param.endtime
    }
  })
  const data = response.data.data[0]
  let weixiu = []
  for(let i = 0;i < data.meter_data.length;i++) {
    let item = {
      id: i + 1,
      sn: data.meter_data[i].fac_id,
      name: data.meter_data[i].fac_name,
      devtype: data.meter_data[i].fac_type,
      errlog: data.meter_data[i].fault_instruction,
      errimg: 'http://47.93.132.27:8000' + data.meter_data[i].fault_photo,
      errdate: data.meter_data[i].fault_time,
      repairlog: data.meter_data[i].resolve_instruction,
      repairimg: 'http://47.93.132.27:8000' + data.meter_data[i].resolve_photo,
      repairdate: data.meter_data[i].repair_time
    }
    weixiu.push(item)
  }
  const result = {
    data: {
      waters: data.repair_count[0].water_count,
      elect: data.repair_count[0].electric_count,
      cold: data.repair_count[0].glass_count,
      liuliang: data.repair_count[0].traffic_count,
      xdata: data.repair_list[0].date_list,
      y1data: data.repair_list[0].electric_count_list,
      y2data: data.repair_list[0].water_count_list,
      y3data: data.repair_list[0].traffic_count_list,
      y4data: data.repair_list[0].glass_count_list,
      weixiu: weixiu
    }
  }
  console.log(result)
  return result
}
